import { getNineChapterParams, xposParamsMap } from '@didi/webx-js-core';
import { storage } from '../storage';
import { getURL } from '../query';
import { getOmega } from '../omega';
import { xenv } from '../xenv';
/**
 * getNineChapterCommonParams: 综合获取九章参数
 * @param url
 * @example
 * ```js
 *  const parameters = getNineChapterCommonParams()
 * ```
 */
const getNineChapterCommonParams = (useStorage = true) => {
    const collection = getNineChapterParams(getURL());
    if (useStorage && storage.webxNineChapterParams) { // 存在通过webx对外服务获取到的九章参数 则以该组参数为主
        const nineChapterParamsKey = [
            'dchn',
            'prod_key',
            'xbiz',
            'xpsid',
            'xoid',
            'xspm_from',
            'xpsid_from',
            'xpsid_root',
            'xpsid_share',
            'xpos_from'
        ];
        nineChapterParamsKey.forEach((key) => {
            if (storage.webxNineChapterParams[key])
                collection[key] = storage.webxNineChapterParams[key] || '';
        });
    }
    collection['xenv'] = xenv();
    if (!collection['xoid'] && getOmega() && getOmega().getXoid)
        collection['xoid'] = getOmega().getXoid();
    /* url参数&productInit请求中均未获取到用户信息的情况下 尝试通过缓存storage获取 */
    if (!collection['uid']) {
        if (storage.userInfo.uid) {
            // 首先尝试从storage缓存中获取之前请求用户信息的记录
            collection['uid'] = String(storage.userInfo.uid);
        }
    }
    return collection;
};
const webxParamsKey = [
    /* 页面信息 */
    'xbiz',
    'prod_key',
    'xpsid',
    'dchn',
    'xoid',
    /* 用户信息 */
    /* 环境信息 */
    'xenv',
    /* 路径信息 */
    'xpsid_root',
    'xpsid_from',
    'xpsid_share',
    'xspm_from',
    'xpos_from'
];
/**
 * getNineChapterWebxParams: 获取webx对外服务模块九章参数
 * @param
 * @example
 * ```js
 *  const parameters = getNineChapterWebxParams()
 * ```
 */
const getNineChapterWebxParams = (useStorage = true) => {
    const collection = getNineChapterCommonParams(useStorage);
    return webxParamsKey.reduce((result, key) => {
        switch (key) {
            case 'xpos_from':
                if (collection['xpos_from']) {
                    /* 处理xpos_from 将其从字符串转为xpos对象 */
                    try {
                        let xposInfo = JSON.parse(decodeURIComponent(collection[key]));
                        /* xpos参数映射 */
                        xposInfo = Object.entries(xposInfo).reduce((res, [key, value]) => {
                            if (xposParamsMap[key]) { // 需要映射 进行key转换
                                res[xposParamsMap[key]] = value;
                            }
                            else {
                                res[key] = value;
                            }
                            return res;
                        }, {});
                        result['xpos_from'] = xposInfo;
                    }
                    catch (err) {
                        console.error('== 运营位参数处理失败 ==', err);
                    }
                }
                else if (collection['xspm_from']) {
                    /* 兼容xspm体系和xpos体系 特殊操作 */
                    /* 如果不存在xpos_from 却存在xspm_from 则尝试使用xspm_from来填充xpos_from */
                    try {
                        const xspm = collection['xspm_from'].split('.')[2];
                        if (xspm !== 'none') {
                            result['xpos_from'] = {
                                [xposParamsMap['prod_key']]: collection['prod_key'],
                                [xposParamsMap['xspm']]: xspm
                            };
                        }
                    }
                    catch (err) {
                        console.error('== 处理运营位参数兼容失败 ==', err);
                    }
                    /* End 兼容xspm体系和xpos体系 特殊操作 */
                }
                break;
            case 'xspm_from':
                if (!collection['xspm_from'] && collection['xpos_from']) {
                    /* 兼容xspm体系和xpos体系 特殊操作 */
                    /* 如果不存在xspm_from 却存在xpos_from 则尝试使用xpos_from来填充xspm_from */
                    try {
                        let xposInfo = JSON.parse(decodeURIComponent(collection['xpos_from']));
                        if (xposInfo['xp'])
                            result['xspm_from'] = `${xposInfo['pk'] || 'none'}.none.${xposInfo['xp']}.${xposInfo['idx'] || 'none'}`;
                    }
                    catch (err) {
                        console.error('== 处理运营位参数兼容失败 ==', err);
                    }
                    /* End 兼容xspm体系和xpos体系 特殊操作 */
                }
                else if (collection[key])
                    result[key] = collection[key];
                break;
            default:
                if (collection[key])
                    result[key] = collection[key];
                break;
        }
        return result;
    }, {});
};
const gotoParamsKey = [
    /* 页面信息 */
    'xoid',
    /* 用户信息 */
    // 'openid',
    // 'token',
    // 'uid',
    /* 环境信息 */
    // 'xenv',
    // 'lat',
    // 'lng',
    // 'cityid',
    /* 路径信息 */
    'xpsid_root',
    'xpsid_from',
    // 'xpsid_share',
    'xspm_from',
    'xpos_from'
];
/**
 * getNineChapterGotoParams: 获取Goto模块九章参数
 * @param
 * @example
 * ```js
 *  const parameters = getNineChapterGotoParams()
 * ```
 */
const getNineChapterGotoParams = (option = {}) => {
    const collection = getNineChapterCommonParams();
    if (collection['xpsid_from'])
        collection['xpsid_from'] = '';
    if (collection['xpsid']) {
        collection['xpsid_from'] = collection['xpsid'];
        if (!collection['xpsid_root'])
            collection['xpsid_root'] = collection['xpsid'];
        collection['xpsid'] = undefined;
    }
    if (option.removeXoid)
        collection['xoid'] = undefined;
    return gotoParamsKey.reduce((result, key) => {
        if (collection[key])
            result[key] = collection[key];
        return result;
    }, {});
};
const sameProductGotoParamsKey = [
    /* 页面信息 */
    'xbiz',
    'prod_key',
    'xpsid',
    'dchn',
    'xoid',
    /* 用户信息 */
    'uid',
    /* 环境信息 */
    'xenv',
    /* 路径信息 */
    'xpsid_root',
    'xpsid_from',
    'xpsid_share',
    'xspm_from'
];
/**
 * getNineChapterSameProductGotoParams: 获取Goto模块九章参数
 * @param
 * @example
 * ```js
 *  const parameters = getNineChapterSameProductGotoParams()
 * ```
 */
const getNineChapterSameProductGotoParams = (option = {}) => {
    const collection = getNineChapterCommonParams();
    if (collection['xpsid_from'])
        collection['xpsid_from'] = '';
    if (option.removeXoid)
        collection['xoid'] = undefined;
    return sameProductGotoParamsKey.reduce((result, key) => {
        if (collection[key])
            result[key] = collection[key];
        return result;
    }, {});
};
const shareParamsKey = [
    /* 路径信息 */
    'xpsid_share'
];
/**
 * getNineChapterGotoParams: 获取Goto模块九章参数
 * @param
 * @example
 * ```js
 *  const parameters = getNineChapterGotoParams()
 * ```
 */
const getNineChapterShareParams = () => {
    const collection = getNineChapterCommonParams();
    if (collection['xpsid']) {
        collection['xpsid_share'] = collection['xpsid'];
        collection['xpsid'] = undefined;
    }
    return shareParamsKey.reduce((result, key) => {
        if (collection[key])
            result[key] = collection[key];
        return result;
    }, {});
};
export { getNineChapterCommonParams, getNineChapterWebxParams, getNineChapterGotoParams, getNineChapterSameProductGotoParams, getNineChapterShareParams };
